import { ICompanyPartField } from 'categories/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getCompanyPartFields = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICompanyPartField>> => {
  const { data } = await partfinitiClient.get(
    `/categories/company-part-field/list?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICompanyPartField>(data.company_part_fields, data.total_count);
};
